// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-content[data-v-41da654e] {\n  padding: 15px;\n  height: calc(100vh - 145px);\n  overflow-y:auto;\n}\n.form-content[data-v-41da654e] .el-form-item__content {\n  line-height: 20px !important;\n}\n.form-content[data-v-41da654e] .el-input.is-disabled .el-input__inner,\n.form-content[data-v-41da654e] .el-textarea.is-disabled .el-textarea__inner {\n  color: #5a6473;\n}\n", ""]);
// Exports
module.exports = exports;
